<div [attr.data-cy]="createDataCy(sectionTitle)" class="pnc-detail-section-title">{{sectionTitle}}</div>
